import React from "react";
import { Platform, ScrollView, StyleSheet, TouchableOpacity, View } from "react-native";
import Header from "../../header/Header";
import Typography from "../../typography/Typography";
import { ButtonTypeDLS, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens } from "@voltmoney/schema";
import Icon from "../../icon/Icon";
import CoBorrowerKycFooter from "./CoBorrowerKycFooter";
import Divider from "../../divider/Divider";
import { Button } from "../../button/Button";
import { isMobileView } from "../../stack/utils";
const CoBorrowerKycSummaryPage = ({ type, height, stepperProps, headerTitle, backAction, triggerAction, coBorrowerList, nextAction, addCoBorrower, retryKYC = true, retryKYCAction, allReKYCsDone }) => {
    return (React.createElement(View, { style: [styles.container, { height: height - 15 }] },
        React.createElement(View, { style: styles.header },
            React.createElement(Header, { id: "bt_coBorrowerDetails_goBack", type: type, stepperProps: stepperProps, isBackButton: true, title: headerTitle, onPress: () => {
                    if (backAction) {
                        triggerAction(backAction);
                    }
                } })),
        React.createElement(View, { style: [styles.homeContainer, { height: height - 120 }] },
            React.createElement(View, { style: styles.kycText },
                React.createElement(Typography, { label: "Complete KYC for joint holder", fontWeight: '600', lineHeight: 24, color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Poppins }),
                React.createElement(Typography, { label: "For mutual funds owned as a joint holding (including anyone or either/or survivor), KYC details of joint holder are required.", fontWeight: '400', lineHeight: 16, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter })),
            React.createElement(View, { style: styles.details },
                React.createElement(Typography, { label: "Co-borrower details", fontWeight: '600', lineHeight: 18, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter })),
            React.createElement(ScrollView, { style: styles.dataContainer, showsVerticalScrollIndicator: false }, coBorrowerList.map((item) => {
                return (React.createElement(React.Fragment, null,
                    React.createElement(View, { style: styles.data },
                        React.createElement(View, { style: styles.iconContainer },
                            React.createElement(TouchableOpacity, null,
                                React.createElement(Icon, { name: IconTokens.Person, color: ColorTokens.Primary_100, size: IconSizeTokens.XXL }))),
                        React.createElement(View, { style: styles.name },
                            React.createElement(Typography, { label: "Name", fontWeight: '400', lineHeight: 18, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter }),
                            React.createElement(Typography, { label: item.coBorrowerName, fontWeight: '500', lineHeight: 20, color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, numberOfLines: 2 })),
                        React.createElement(View, { style: styles.divider }),
                        React.createElement(View, { style: styles.rightContainer },
                            React.createElement(Typography, { label: "PAN Number", fontWeight: '400', lineHeight: 18, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter }),
                            React.createElement(Typography, { label: item.coBorrowerPanNumber, fontWeight: '500', lineHeight: 20, color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, numberOfLines: 1 })),
                        React.createElement(View, { style: {
                                width: isMobileView() ? '25%' : '28%',
                                alignItems: 'center',
                                alignContent: 'center',
                                alignSelf: 'center'
                            } }, item?.reKYCNeeded ? React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, height: 30, label: "Start KYC", paddingHorizontalDC: 0, onPress: () => {
                                if (retryKYCAction) {
                                    triggerAction({
                                        ...retryKYCAction,
                                        payload: {
                                            value: item?.coBorrowerAccountId,
                                            coBorrowerName: item?.coBorrowerName
                                        }
                                    });
                                }
                            } }) :
                            React.createElement(View, { style: { alignItems: 'center', alignContent: 'center' } },
                                React.createElement(Icon, { name: IconTokens.SuccessIcon1, size: IconSizeTokens.XXXL }),
                                React.createElement(View, { style: { marginTop: 4 } },
                                    React.createElement(Typography, { label: "KYC completed", color: ColorTokens.Grey_Smoke, fontSize: FontSizeTokens.SIZE_8 }))))),
                    React.createElement(Divider, { size: DividerSizeTokens.SM, margin: { vertical: SizeTypeTokens.LG }, color: ColorTokens.Grey_Chalk })));
            }))),
        React.createElement(CoBorrowerKycFooter, { nextAction: nextAction, addCoBorrower: addCoBorrower, triggerAction: triggerAction, allReKYCsDone: allReKYCsDone })));
};
const styles = StyleSheet.create({
    container: {
        //flex:1,
        marginHorizontal: -16,
    },
    homeContainer: {
        flex: 1,
    },
    header: {
        ...Platform.OS === "ios" && {
            marginTop: 16
        }
    },
    kycText: {
        marginTop: 24,
        marginHorizontal: 16,
    },
    details: {
        marginTop: 30,
        marginHorizontal: 16,
    },
    dataContainer: {
        marginTop: 24,
        marginHorizontal: 16,
        marginBottom: 140,
    },
    data: {
        flexDirection: "row",
        paddingBottom: Platform.OS !== "ios" ? 0 : 24,
    },
    iconContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#F3F5FC',
        borderRadius: 100,
        padding: 8,
        height: 40,
        width: 40,
    },
    divider: {
        justifyContent: 'center',
        borderWidth: 1,
        borderColor: '#F3F5FC',
    },
    name: {
        marginLeft: 12,
        marginRight: isMobileView() ? 2 : 9,
        width: isMobileView() ? '23%' : '28%',
    },
    rightContainer: {
        width: isMobileView() ? '30%' : '25%',
        marginLeft: isMobileView() ? 12 : 24,
    }
});
export default CoBorrowerKycSummaryPage;
